import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  loggedInUserDetails: {}
};

const authenticatedUserSlice = createSlice({
  name: "authenticatedUserSlice",
  initialState,
  reducers: {
    saveAuthedUserDetails: (state, action) => {

      if (!!action.payload) {
        const userDetails = action.payload

        state.loggedInUserDetails = userDetails
      }
    },
  }
})

export const { saveAuthedUserDetails } = authenticatedUserSlice.actions;

export default authenticatedUserSlice.reducer;
